/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module heading
 */

import Heading from './heading';
import HeadingEditing from './headingediting';
import HeadingUI from './headingui';
import HeadingButtonsUI from './headingbuttonsui';

export default {
	Heading,
	HeadingEditing,
	HeadingUI,
	HeadingButtonsUI
};
